<template>
  <div class="data-statistics">
    <div class="stats-row">
      <ServiceChannelStatistics class="stats-row__item" />
      <ServiceMemberConversion class="stats-row__item" />
    </div>
    <BusinessHandlingStatistics />
    <BusinessGrowthTrend />
  </div>
</template>

<script setup>
/**
 * 一级渠道数据统计：对接后端已有接口
 * - serviceChannelStatistics
 * - serviceMemberConversionStatistics
 * - businessHandlingOverviewStatistics / businessHandlingSubChannelStatistics
 * - businessGrowthTrend
 *
 * serviceSubChannel* 四接口暂不挂载，以后需要再加。
 */
import ServiceChannelStatistics from './ServiceChannelStatistics.vue'
import ServiceMemberConversion from './ServiceMemberConversion.vue'
import BusinessHandlingStatistics from './BusinessHandlingStatistics.vue'
import BusinessGrowthTrend from './BusinessGrowthTrend.vue'
</script>

<style lang="scss" scoped>
.data-statistics {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 4px 0;
  flex-direction: column;
  gap: 16px;
}

.stats-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 16px;
  width: 100%;
  min-width: 0;
}

.stats-row__item {
  min-width: 0;
}

@media (max-width: 1024px) {
  .stats-row {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .data-statistics {
    gap: 14px;
  }
}
</style>
